import { padding } from 'polished'

export const __input = props => {
	const { theme, hasError, readOnly } = props
	const primary = theme.primary(theme)

	return {
		...padding(10, 10, 10, 0),
		position: 'relative',
		display: 'block',
		width: 'calc(100% - 14px)',
		border: 'none',
		backgroundColor: 'transparent',
		borderBottom: hasError
			? `1px solid ${primary.errorColor}`
			: `1px solid ${primary.backgroundColor}`,
		onFocus: {
			outline: 'none',
		},
		borderColor: primary.borderColor,
		zIndex: 1,
		extend: {
			condition: readOnly,
			style: {
				color: primary.formTextColor,
			},
		},
	}
}

export const __label = props => {
	const { theme, isActive, hasData, labelLength } = props
	const primary = theme.primary(theme)

	return {
		border: 'none',
		color: isActive ? primary.backgroundColor : primary.formTextColor,
		fontSize: theme.font.size16,
		transition: 'top 400ms, transform 400ms',
		position: 'absolute',
		top: 10,
		pointerEvents: 'none',
		extend: [
			{
				condition: !isActive || !hasData,
				style: {
					mobileXs: {
						top: labelLength >= 40 ? -10 : 10,
					},
					mobileX: {
						top: labelLength > 45 ? -10 : 10,
					},
				},
			},
			{
				condition: isActive || hasData,
				style: {
					fontSize: theme.font.size12,
					mobileXs: {
						top: labelLength > 45 ? -28 : -15,
					},
					mobileX: {
						top: labelLength > 57 ? -28 : -15,
					},
					mobileXl: {
						transform: 'translateY(-25px)',
					},
					tabletXS: {
						transform: 'translateY(-25px)',
					},
				},
			},
		],
	}
}

export const __bar = props => {
	const { theme, hasError, isActive, readOnly, disableBackground } = props
	const primary = theme.primary(theme)

	return {
		// eslint-disable-next-line
		background: disableBackground
			? hasError
				? primary.errorColor
				: primary.backgroundColor
			: 'none',
		position: 'absolute',
		left: '50%',
		// bottom: 0,
		transform: 'translateX(-50%)',
		width: 0,
		height: 1,
		transition: 'width 0.4s',
		extend: {
			condition: isActive && !readOnly,
			style: {
				width: '100%',
			},
		},
	}
}

export const __wrapper = props => ({
	position: 'relative',
	marginBottom: 20,
	marginTop: 50,
	display: 'flex',
	// follow google spec by default
	width: props.fullWidth ? '100%' : '200px',
})

export const __text = props => {
	const { theme, hasError } = props
	const primary = theme.primary(theme)

	return {
		color: hasError ? primary.errorColor : theme.colors.darkGrey5,
		fontSize: theme.font.size12,
		marginTop: '4px',
		'> svg': {
			marginRight: '4px',
			marginTop: '-2px',
		},
	}
}

const singleLineHeight = 19

export const __placeholder = props => {
	const { theme, rows, multiLine } = props
	const primary = theme.primary(theme)

	return {
		fontSize: theme.font.size16,
		color: primary.formTextColor,
		top: multiLine ? '20px' : '10px',
		position: 'absolute',
		left: '0px',
		textAlign: 'left',
		padding: `0 ${theme.spaces[12]}`,
		overflow: 'auto',
		width: '100%',
		height: `${rows ? rows * singleLineHeight : singleLineHeight}px`,
		zIndex: 0,
	}
}

export const __addon = props => {
	const { theme, hasError } = props
	const primary = theme.primary(theme)

	return {
		alignSelf: 'flex-end',
		borderBottom: hasError
			? `1px solid ${primary.errorColor}`
			: `1px solid ${primary.borderColor}`,
	}
}
export const __clear = () => {
	return {
		display: 'none',
		position: 'absolute',
		top: 8,
		right: 0,
		zIndex: 2,
		'> button': {
			appearance: 'none',
			border: 'none',
			background: 'transparent',
			outline: 'none',
			cursor: 'pointer',
		},
	}
}

export const __SvgSize = props => {
	const { top = 0, right = 0, isLoader, absolute } = props
	const __showKeyFrame = () => ({
		'0%': { transform: 'rotate(0deg)' },
		'100%': { transform: 'rotate(360deg)' },
	})

	return {
		'> svg': {
			zIndex: 2,
			extend: [
				{
					condition: absolute,
					style: {
						position: 'absolute',
						top,
						right,
						zIndex: 1,
					},
				},
				{
					condition: isLoader,
					style: {
						animationName: __showKeyFrame(),
						animationDuration: '1000ms',
						animationTimingFunction: 'linear',
						animationIterationCount: 'infinite',
					},
				},
			],
		},
	}
}
